export enum HighlightStatus {
  None,
  Success,
  Failed,
  Darkest,
  Dark,
  Light,
  Lightest,
}
